import DefaultEdge from './DefaultEdge';
import AnimatedEdge from './AnimatedEdge';
import WorkflowEdgeWrapper from './WorkflowEdgeWrapper';

export const edgeTypes = {
  default: DefaultEdge,
  animated: AnimatedEdge,
  workflow: WorkflowEdgeWrapper,
};

export { default as WorkflowEdge } from './WorkflowEdge'; 